import { Box } from '@mui/material';
import React from 'react';
import logo from "../../assets/images/logo_TS.png";
import css from './TeamsystemAppBar.module.css';
import { VdsButton } from '../../@vds';

type TeamsystemAppBarComponent = React.FC<{
    hideActions?: boolean
}>;

export const TeamsystemAppBar: TeamsystemAppBarComponent = (props) => {
    
    const { hideActions } = props;

    return (
        <Box className={css.root}>
            <Box className={css.navbarWrapper}>
                <Box flexGrow={1}>
                    <img src={logo} className={css.navbarWrapperLogo} alt="Logo" />
                </Box>
                {!hideActions && (
                    <VdsButton
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            window.location.href = "/Account/OnPostLogin?clear=true&returnUrl=/app";
                        }}
                        sx={{
                            width: '100px',
                        }}
                    >
                        Logout
                    </VdsButton>
                )}
            </Box>
        </Box>
    );
}
